import React, { useState } from 'react';
import { 
  sendTestInvoiceToEmmanuel, 
  sendTestPaymentReminder, 
  sendTestPaymentConfirmation 
} from '../utils/testInvoiceEmail';
import { toast } from 'react-toastify';
import { FiMail, FiClock, FiCheckCircle, FiSend } from 'react-icons/fi';

export const TestInvoiceSender: React.FC = () => {
  const [isSending, setIsSending] = useState(false);
  const [lastSent, setLastSent] = useState<string>('');

  const handleSendInvoice = async () => {
    setIsSending(true);
    try {
      const result = await sendTestInvoiceToEmmanuel();
      if (result) {
        toast.success('Test invoice sent successfully to emmanuel@sibanda.africa!');
        setLastSent('Invoice');
      } else {
        toast.error('Failed to send test invoice');
      }
    } catch (error) {
      toast.error('Error sending test invoice');
    } finally {
      setIsSending(false);
    }
  };

  const handleSendReminder = async () => {
    setIsSending(true);
    try {
      const result = await sendTestPaymentReminder();
      if (result) {
        toast.success('Test payment reminder sent successfully!');
        setLastSent('Payment Reminder');
      } else {
        toast.error('Failed to send test reminder');
      }
    } catch (error) {
      toast.error('Error sending test reminder');
    } finally {
      setIsSending(false);
    }
  };

  const handleSendConfirmation = async () => {
    setIsSending(true);
    try {
      const result = await sendTestPaymentConfirmation();
      if (result) {
        toast.success('Test payment confirmation sent successfully!');
        setLastSent('Payment Confirmation');
      } else {
        toast.error('Failed to send test confirmation');
      }
    } catch (error) {
      toast.error('Error sending test confirmation');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div style={{ 
      padding: '2rem', 
      background: 'white', 
      borderRadius: '12px', 
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      maxWidth: '600px',
      margin: '2rem auto'
    }}>
      <h2 style={{ 
        color: '#1f2937', 
        marginBottom: '1.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem'
      }}>
        <FiMail size={24} />
        Test Invoice Email Sender
      </h2>
      
      <div style={{ 
        background: '#f3f4f6', 
        padding: '1rem', 
        borderRadius: '8px', 
        marginBottom: '1.5rem',
        border: '1px solid #e5e7eb'
      }}>
        <h3 style={{ color: '#374151', marginBottom: '0.5rem' }}>Test Recipient:</h3>
        <p style={{ color: '#6b7280', margin: 0 }}>
          <strong>Email:</strong> emmanuel@sibanda.africa<br />
          <strong>Name:</strong> Emmanuel Sibanda<br />
          <strong>Invoice:</strong> INV-2024-001 (R2,500.00)
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <button
          onClick={handleSendInvoice}
          disabled={isSending}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            background: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: isSending ? 'not-allowed' : 'pointer',
            opacity: isSending ? 0.6 : 1,
            transition: 'all 0.2s'
          }}
        >
          <FiSend size={20} />
          {isSending ? 'Sending...' : 'Send Test Invoice'}
        </button>

        <button
          onClick={handleSendReminder}
          disabled={isSending}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            background: '#f59e0b',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: isSending ? 'not-allowed' : 'pointer',
            opacity: isSending ? 0.6 : 1,
            transition: 'all 0.2s'
          }}
        >
          <FiClock size={20} />
          {isSending ? 'Sending...' : 'Send Payment Reminder'}
        </button>

        <button
          onClick={handleSendConfirmation}
          disabled={isSending}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            padding: '0.75rem 1.5rem',
            background: '#10b981',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: isSending ? 'not-allowed' : 'pointer',
            opacity: isSending ? 0.6 : 1,
            transition: 'all 0.2s'
          }}
        >
          <FiCheckCircle size={20} />
          {isSending ? 'Sending...' : 'Send Payment Confirmation'}
        </button>
      </div>

      {lastSent && (
        <div style={{ 
          marginTop: '1.5rem',
          padding: '1rem',
          background: '#dbeafe',
          borderRadius: '8px',
          border: '1px solid #93c5fd',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <FiCheckCircle size={20} color="#2563eb" />
          <span style={{ color: '#1e40af' }}>
            Last sent: <strong>{lastSent}</strong> to emmanuel@sibanda.africa
          </span>
        </div>
      )}

      <div style={{ 
        marginTop: '1.5rem',
        padding: '1rem',
        background: '#fef3c7',
        borderRadius: '8px',
        border: '1px solid #fcd34d'
      }}>
        <h4 style={{ color: '#92400e', marginBottom: '0.5rem' }}>Note:</h4>
        <p style={{ color: '#78350f', margin: 0, fontSize: '0.875rem' }}>
          This is a test environment. Emails are logged to the console but not actually sent.
          In production, this would send real emails using your configured email service.
        </p>
      </div>
    </div>
  );
};
